import { useCallback } from 'react';

import { useSetAtom } from 'jotai';

import { draftFoldersAtom } from '../../../../store/fileSystem.js';
import type { FolderNode } from '../../../../types/fileSystem.js';

// FYI: this is expected to be replaced once folder creation and deletion move
// to the API. The server will most likely cascade the delete itself, and the
// stored shape may not be a flat parentId list at all, so revisit the approach
// here rather than porting it as is.
const collectSubtreeIds = (folders: FolderNode[], rootIds: string[]) => {
  const doomed = new Set(rootIds);

  let grown = true;

  while (grown) {
    grown = false;

    for (const folder of folders) {
      if (!doomed.has(folder.id) && doomed.has(folder.parentId)) {
        doomed.add(folder.id);
        grown = true;
      }
    }
  }

  return doomed;
};

export const useDeleteFolders = () => {
  const setFolders = useSetAtom(draftFoldersAtom);

  const deleteFolders = useCallback(
    (ids: string[]) => {
      if (!ids.length) return;

      setFolders((prev) => {
        const doomed = collectSubtreeIds(prev, ids);

        return prev.filter((folder) => !doomed.has(folder.id));
      });
    },
    [setFolders],
  );

  return { deleteFolders };
};
